import React, { useEffect, useState } from "react";
import {   
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(ArcElement,   CategoryScale,
  LinearScale,
  BarElement,
  Title, Tooltip, Legend);

const AditionalsPaymentOthers = ({ aditionalPayment }) => {
  const [ dataValues, setDataValues] = useState({});
  
  const options = {
    indexAxis: 'y',
    maintainAspectRatio: false,
    responsive: true,
    height: 300,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Otros Ingresos (Adicionales)',
      },
    },
  };

  const colors = [
    'rgba(255, 99, 132)',
    'rgba(54, 162, 235)',
    'rgb(56 199 29)',
    'rgb(145 16 240)',
    'rgb(185 15 175)',
    'rgb(255 131 0)',
  ];

  useEffect(()=>{
    let labels = [];
    let values = [];
    let valueColors = [];
    let i = 0;
    if(aditionalPayment){
      aditionalPayment.map(item=>{
        labels.push(item.description);
        values.push(item.total);
        valueColors.push(colors[i]);
        i++;
      });
    }
    
    setDataValues({
      labels: labels,
      values: values,
      colors: colors,
    });
  },[aditionalPayment])

  const dataAditionalPayment = {
    labels: dataValues.labels,
    datasets: [
      {
        label: 'Ingresos',
        data: dataValues.values,
        backgroundColor: 'rgba(54, 162, 235)',
      },
    ],
  };

  return (
    <div className="p-10 h-96 sm:col-span-3">
      <Bar options={options} data={dataAditionalPayment} />
    </div>
  );
};

export default AditionalsPaymentOthers;
